export default {
  baseURL: 'https://pdf.41devs.com/',
  sendEmail: 'api/v1/kmailler/send'
}
